import type { FaireProductEntity } from "../../entity_types/product";

export const p_69c979kjj8: FaireProductEntity = {
  token: "p_69c979kjj8",
  type: "product",
  name: "Vertly Discovery Bundle",
  brandToken: "b_9mdx220frm",
  brandName: "Vertly",
  imageUrl:
    "https://cdn.faire.com/fastly/d851ac46678e57e28f0491668724f2df100ac727810c1e5f228aaea69197b1f0.jpeg",
  galleryImageUrls: [],
  priceDollars: 175,
  description:
    "Discover the full Vertly experience in one curated bundle — perfect for a store that wants to sample it all. Each product is handcrafted in small batches with freshly extracted botanicals, slow-infused for weeks to capture every drop of plant goodness.\n\nBundle includes one of these favorites:\n\n• Relief Lotion – Arnica + Magnesium for tired muscles and all-over recovery\n• Body Oil – Pure hydration with freshly extracted herbs\n• Peppermint Lip Butter + Rose Tinted Lip Butter – Nourishing plant-based moisture for lips\n• Travel Trio Soak Kit – Muscle, Eucalyptus, and Floral Soaks in travel sizes for relaxation on-the-go\n• Glowing Skin Face Serum – Calming, glow-restoring hydration for skin\n• Face Mist – Refresh and replenish with a fine botanical mist\n• Cooling Spray – A soothing blast of peppermint, aloe, and CBD\n\n• Value: $300 retail value\n\n• Limit: One bundle per store\n\nThis is the ultimate way to experience the Vertly ritual from head to toe — crafted to soothe, hydrate, and restore.",
  tags: [],
  msrpDollars: 300,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:33.667Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
